import { defineComponent as _defineComponent } from 'vue';
import { useAlarmList } from '@blade-sxp/monitoring-center/pages/alarm/utils/useAlarmList';
import CardBox from '@blade-sxp/monitoring-center/pages/alarm/components/card-box.vue';
import AlarmDetails from '@blade-sxp/monitor-center/pages/components/alarm-details/index.vue';
import { onUnmounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'alarm-list',
    setup(__props) {
        const { initWebSocket, checkPermission, fetchAlarmList, handleAlarmCenter, updateDialog, confirmDialog, closeDialog, closeWebSocket, showMsgList, dialogVisible, alarmDetail, } = useAlarmList();
        // 权限校验
        if (checkPermission()) {
            // 获取告警列表
            fetchAlarmList();
            // 初始化ws
            initWebSocket();
        }
        onUnmounted(() => closeWebSocket());
        return { __sfc: true, initWebSocket, checkPermission, fetchAlarmList, handleAlarmCenter, updateDialog, confirmDialog, closeDialog, closeWebSocket, showMsgList, dialogVisible, alarmDetail, CardBox, AlarmDetails };
    }
});
